var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinelinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4202085_linkedin_logo_social_social media_icon 19",
    clipPath: "url(#clip0_0_9556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35_6-linkedin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.90936 3.89697H0.408203V11.6072H2.90936V3.89697Z",
    fill: "#1B80E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.72198 3.98739C9.69543 3.97907 9.67026 3.96998 9.64239 3.96213C9.60869 3.95446 9.57524 3.94807 9.54095 3.94261C9.40825 3.91591 9.26263 3.897 9.09217 3.897C7.6341 3.897 6.70909 4.9604 6.4045 5.37107V3.89697H3.90332V11.6072H6.40448V7.40165C6.40448 7.40165 8.29455 4.76193 9.09215 6.70061V11.6072H11.5926V6.40425C11.5926 5.23921 10.7964 4.26846 9.72198 3.98739Z",
    fill: "#1B80E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.85487 1.61918C2.85487 2.29673 2.30706 2.84583 1.63155 2.84583C0.955984 2.84583 0.408203 2.29671 0.408203 1.61918C0.408203 0.941766 0.955984 0.392578 1.63155 0.392578C2.30706 0.392578 2.85487 0.941766 2.85487 1.61918Z",
    fill: "#1B80E4"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_9556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinelinkedin);
export default __webpack_public_path__ + "static/media/outlinelinkedin.1e772fc3b81f8bda08174d6955009647.svg";
export { ForwardRef as ReactComponent };